import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, computed, input } from '@angular/core';
import { ReportPage } from '@cfp/features-shared/portfolio-buildings-roadmap-report';
import { Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { LloydsDecarbonisationPathwayDTO } from 'csr-asset-app';
import { LbgDecarbonisationPathwayChart } from '../../components/lbg-decarbonisation-pathway-chart';

const TRANSLATION_KEY_PREFIX = 'lbgPortfolioRoadmapReport';

@Component({
  selector: 'cfp-lbg-report-decarbonisation-pathway-pages',
  templateUrl: 'report-decarbonisation-pathway-pages.html',
  styleUrls: ['report-decarbonisation-pathway-pages.scss'],
  imports: [ReportPage, LbgDecarbonisationPathwayChart, Icon, TranslateModule, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgReportDecarbonisationPathwayPages {
  public readonly customerName = input.required<string>();
  public readonly residentialPathway = input<LloydsDecarbonisationPathwayDTO | undefined>(undefined);
  public readonly nonResidentialPathway = input<LloydsDecarbonisationPathwayDTO | undefined>(undefined);
  public readonly headerLogo = input<string | undefined>(undefined);
  public readonly chromeFooter = input<TemplateRef<unknown> | undefined>(undefined);

  protected readonly translationKeyPrefix = TRANSLATION_KEY_PREFIX;

  protected readonly showResidentialPathway = computed(() => {
    const pathway = this.residentialPathway();
    return !!pathway?.years?.length;
  });

  protected readonly showNonResidentialPathway = computed(() => {
    const pathway = this.nonResidentialPathway();
    return !!pathway?.years?.length;
  });
}
